import logger from "loglevel";

logger.setLevel(logger.levels.DEBUG);

class LogWrapper {
    static error(message, err) {
        logger.error(message, err);
    }
    static info(message) {
        logger.info(message);
    }
    static warn(message) {
        logger.warn(message);
    }
    static debug(message) {
        logger.debug(message);
    }
    static trace(message) {
        logger.trace(message);
    }
}

export default LogWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/Logger.js